import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSkillsetTagsRequest } from "../store/skillsetTagsSlice";
import {
  selectSkillsetTags,
  selectAreSkillsetTagsLoading,
} from "../store/selectors";

export function useSkillsetTags() {
  const dispatch = useDispatch();
  const tags = useSelector(selectSkillsetTags);
  const loading = useSelector(selectAreSkillsetTagsLoading);

  useEffect(() => {
    dispatch(fetchSkillsetTagsRequest());
  }, [dispatch]);

  return { tags, loading };
}